module.exports = __webpack_public_path__ + "static/media/Shield.1b2579c6.jpg";